import * as React from 'react';
import { FC } from 'react';

import { StyledLockClock, UpcomingOfferIconContainer } from './upcoming-offer.styled';

export const UpcomingOffer: FC = props => (
  <UpcomingOfferIconContainer {...props}>
    <StyledLockClock fill={Styles.color.white} />
  </UpcomingOfferIconContainer>
);
